import { Space, Tag, Typography } from "antd";
import PropTypes from 'prop-types';
import { STATUTS } from "./utils";
import { MobileOutlined } from "@ant-design/icons";

export const StatusHeader = ({ status, isMobile, numeroSinistre }) => {
    const statusInfo = STATUTS[status] || STATUTS.I;

    return (
        <div style={{ marginBottom: 24 }}>
            <Space size="small" wrap>
                <Tag color={statusInfo.color} style={{ fontSize: 14, padding: '4px 12px' }}>
                    <div style={{ color: "black" }} >{statusInfo.label}</div>
                </Tag>
                {isMobile && (
                    <Tag color="geekblue" icon={<MobileOutlined />}>
                        Mobile
                    </Tag>
                )}
            </Space>
            <Typography.Title level={3} style={{ color: statusInfo.titleColor, marginTop: 12 }}>
                Sinistre N° {numeroSinistre}
            </Typography.Title>
        </div>
    );
};

StatusHeader.propTypes = {
    status: PropTypes.string.isRequired,
    isMobile: PropTypes.bool,
    numeroSinistre: PropTypes.string.isRequired
};